import { lazyOnItemNavigation, SelectionType } from 'owa-addins-core';
import { isFeatureEnabled } from 'owa-feature-flags';

export default async function updateAddinOnItemNavigation(
    selectionType: SelectionType,
    hostItemIndex: string = null
) {
    isFeatureEnabled('rp-addins') &&
        isFeatureEnabled('addin-persistentTaskPane') &&
        (await lazyOnItemNavigation.import())(selectionType, hostItemIndex);
}
